import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { UpdateCwsIconDataVo } from '../vo/update-cws-icon-data.model'

/**
 * アイコン情報更新
 *
 * @export
 * @class UpdateCwsIconData
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateCwsIconData extends PlessJsonResponderSub<any> {
  private vo: UpdateCwsIconDataVo;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof UpdateCwsIconData
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        IconCode: this.vo.iconCode,
        IconName: this.vo.iconName,
        GroupCode: this.vo.groupCode,
        IconDiv: this.vo.iconDiv,
        ArrangeDiv: this.vo.arrangeDiv,
        IconExplain: this.vo.iconExplain,
        OutputDiv: this.vo.outputDiv,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @memberof UpdateCwsIconData
   */
  execute(vo: UpdateCwsIconDataVo, successFunc: Function = null): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('updateCwsIconData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof UpdateCwsIconData
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
